<style lang="scss">
  @import '../resources/scss/strategy.scss';
</style>

<script lang="ts">
  import type { Strategy } from '../api/rest/directus-cms/about/models/Strategy'

  export let strategy: Strategy
</script>

{#if strategy}
  <section id="strategy">
    <div class="container-fluid pt-section">
      <div class="container-xxl">
        <h1 class="text-primary-orange pb-2">{strategy.title}</h1>
      </div>
    </div>
    <div
      class="container-fluid strategy-image"
      style="--strategy-bg-image: url({strategy.image?.fullUrl});"
    >
      <div class="container-xxl pt-3 pb-section">
        <div class="row">
          {#each strategy.items as item}
            <div class="col-12 col-lg-4 mb-4 mb-lg-0">
              <h4 class="text-primary-orange pb-2">{item.title}</h4>
              <div class="text-neutral-a mb-0">
                {@html item.text}
              </div>
            </div>
          {/each}
        </div>
      </div>
    </div>
  </section>
{/if}
